export const INITIAL_AUTH = {
    accessToken: '',
    refreshToken: '',
};
